<script setup>
import MWILoginForm from "@/components/mwi/MWILoginForm.vue"
</script>

<template>
  <MWILoginForm />
</template>
